<template lang="html">
  <item-editor-dialog
    :id="selectedItemId"
    ref="editForm"
    v-model="selectedPanel"
    :show="showItem"
    :clone-id="cloneId"
    :title="pageTitle"
    :on-close="doClose"
    :context-menu="defaultContextMenu"
    :lock-timer="lockTimerSettings"
    :loading="isDataLoading"
    :errors="errors"
    :edit-panel-id="editPanel"
    :audit-panel-id="auditPanel"
    :audit="auditHistorySettings"
    :buttons="pageBarButtons"
  >
    <!-- START OF FORM FIELDS -->
    <v-flex class="pa-3">
      <v-text-field
        v-model.trim="itemData.name"
        :label="type + ' Name'"
        :rules="rules().required('Name')"
        :error-messages="getPathErrors(jsonPath, 'name')"
        :disabled="isFormDisabled"
        required
        @input="clearPathErrors(jsonPath, 'name')"
      />

      <v-textarea
        v-model.trim="itemData.notes"
        label="Comments"
        :rows="1"
        auto-grow
        :error-messages="getPathErrors(jsonPath, 'notes')"
        :disabled="isFormDisabled"
        @input="clearPathErrors(jsonPath, 'notes')"
      />


      <v-text-field
        v-model.trim="itemData.coversPerQtrHour"
        label="Max. Covers Per Qtr Hour"
        type="number"
        :error-messages="getPathErrors(jsonPath, 'coversPerQtrHour')"
        :disabled="isFormDisabled"
        @blur="itemData.coversPerQtrHour = forceInt(itemData.coversPerQtrHour)"
        @input="clearPathErrors(jsonPath, 'coversPerQtrHour')"
      />


      <v-text-field
        v-model.trim="itemData.memberCoversPerQtrHour"
        label="Max. Member Made Covers Per Qtr Hour"
        type="number"
        :error-messages="getPathErrors(jsonPath, 'memberCoversPerQtrHour')"
        :disabled="isFormDisabled"
        @blur="itemData.memberCoversPerQtrHour = forceInt(itemData.memberCoversPerQtrHour)"
        @input="clearPathErrors(jsonPath, 'memberCoversPerQtrHour')"
      />

      <v-boolean
        v-model="itemData.disabled"
        label="Enabled"
        invert
        :error-messages="getPathErrors(jsonPath, 'disabled')"
        :field-errors="getPathErrors(jsonPath, 'disabled')"
        :disabled="isFormDisabled"
      />
    </v-flex>
    <!-- END OF FORM FIELDS -->
  </item-editor-dialog>
</template>

<script>
import {itemEdit} from '@/ft-vue-core'

var itemDefault = {
  name: '',
  notes: '',
  coversPerQtrHour: null,
  memberCoversPerQtrHour: null,
  disabled: false,
  id: null,
  recordLockExpiration: null
}

export default {
  name: 'KitchensItem',
  components: {
  },
  mixins: [itemEdit],
  data: function () {
    return {
      type: 'Kitchen',
      types: 'Kitchens',
      apiRecordCommand: 'diningKitchen',
      itemDefault: itemDefault
    }
  },
  computed: {
  }
}
</script>
